import { all, put, call, takeLatest } from 'redux-saga/effects';
import * as actions from 'reducer/actionTypes'
import * as api from 'script/api'

const resultCodeMessageKeyMap = {
	6989: 'lu.button.msg.apply.fail.6989',
	6995: 'lu.button.msg.apply.fail.6995',
	6996: 'lu.button.msg.apply.fail.6996',
	6997: 'lu.button.msg.apply.fail.6997',
	6998: 'lu.button.msg.apply.fail.6998',
	6890: 'lu.button.msg.auth.fail.network',
	6892: 'lu.button.msg.auth.fail.signature',
	6891: 'lu.button.msg.auth.fail.parsing',
	6895: 'lu.button.msg.auth.fail.server'
};

const getResultMessageKey = (resultCode) => {
	if (resultCode == null) {
		return 'internal.server.error';
	}
	const numericCode = Number(resultCode);
	return resultCodeMessageKeyMap[numericCode] || 'internal.server.error';
};

export default function* fetchLicense() {

	yield all([
		takeLatest(actions.FETCH_GET_LICENSE_INFO_REQUEST, licenseInfo),
		takeLatest(actions.FETCH_SET_LICENSE_UPDATE_REQUEST, licenseRegister), 
		takeLatest(actions.FETCH_EXPORT_DATA_REQUEST,  licenseExportData),
		takeLatest(actions.FETCH_MANUAL_AUTH_REQUEST, manualAuth),
	])
}

function* licenseInfo(params) {
	try {
		const result = yield call(api.licenseInfo)
		if (result.data.resultCode > 0) {
			// 에러 다이얼로그 표시
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: getResultMessageKey(result.data.resultCode),
				isError: true
			})
			
			// value가 있으면 정보도 표시 (만료일 확인용)
			if (result.data.value) {
				yield put({
					type: actions.FETCH_GET_LICENSE_INFO_SUCCESS,
					value: result.data.value
				})
				
				// 라이선스 정보에 포함된 마지막 인증 시간 처리
				if (result.data.value.lastAuthDate) {
					yield put({
						type: actions.SET_LAST_AUTH_TIME,
						lastAuthTime: null, // timestamp는 없고 date만 있음
						lastAuthDate: result.data.value.lastAuthDate
					});
				}
			}
		} else {
			yield put({
				type: actions.FETCH_GET_LICENSE_INFO_SUCCESS,
				value: result.data.value
			})
			
			// 라이선스 정보에 포함된 마지막 인증 시간 처리
			if (result.data.value && result.data.value.lastAuthDate) {
				yield put({
					type: actions.SET_LAST_AUTH_TIME,
					lastAuthTime: null, // timestamp는 없고 date만 있음
					lastAuthDate: result.data.value.lastAuthDate
				});
			}
		}

	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: 'internal.server.error',
			isError: true
		})

		yield put({
			type: actions.FETCH_GET_LICENSE_INFO_FAILURE,
			error:error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
			})

	}
}

function* licenseRegister(params){
	try {
		const result = yield call(api.licenseRegister,params)

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.SET_LICENSE_UPDATE_ERRORLABEL,
				errorLabel: result.data.errorLabel
			})
		} else {
			yield put({
				type: actions.SET_LICENSE_UPDATE_MODAL,
			})

			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.saved",
				isError: false

			})
			// reload
			yield put({
				type: actions.FETCH_GET_LICENSE_INFO_REQUEST
			})
		}

		yield put({
			type: actions.FETCH_SET_LICENSE_UPDATE_SUCCESS,
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: 'internal.server.error',
			isError: true
		})
		yield put({
			type: actions.FETCH_SET_LICENSE_UPDATE_FAILURE,
			error: error.message
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}


function* licenseExportData(action) {
	try {
		const result = yield call(api.licenseExportData, action.params);

		const url = window.URL.createObjectURL(new Blob([result.data]));
		const link = document.createElement('a');
		link.href = url;

		const contentDisposition = result.headers['content-disposition'];
		let fileName = 'export_data.tle';
		if (contentDisposition) {
			const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
			if (fileNameMatch.length === 2) {
				fileName = fileNameMatch[1];
			}
		}
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		yield put({
			type: actions.FETCH_EXPORT_DATA_SUCCESS,
		});
	} catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: 'internal.server.error',
			isError: true
		});
		yield put({
			type: actions.FETCH_EXPORT_DATA_FAILURE,
			error: error.message
		});
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		});
	}
}

function* manualAuth() {
	try {
		const result = yield call(api.manualAuth);

		// 백엔드 응답 형식: {status: "success|error", message: "...", lastAuthTime: "...", lastAuthDate: "..."}
	if (result.data.status === "success") {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.manual.auth.success",
				isError: false
			});
			
			// 마지막 인증 시간 정보를 Redux state에 저장
			if (result.data.lastAuthTime || result.data.lastAuthDate) {
				yield put({
					type: actions.SET_LAST_AUTH_TIME,
					lastAuthTime: result.data.lastAuthTime,
					lastAuthDate: result.data.lastAuthDate
				});
			}
		} else if (result.data.status === "error") {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: getResultMessageKey(result.data.errorCode),
				isError: true,
				resultCode: result.data.errorCode
			});
		} else if (result.data.status === "disabled") {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "Server authentication is disabled",
				isError: true
			});
		}

		yield put({
			type: actions.FETCH_MANUAL_AUTH_SUCCESS,
		});

		// 인증 성공 후 라이선스 정보 새로고침
		yield put({
			type: actions.FETCH_GET_LICENSE_INFO_REQUEST
		});
	} catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: 'internal.server.error',
			isError: true
		});
		yield put({
			type: actions.FETCH_MANUAL_AUTH_FAILURE,
			error: error.message
		});
	} finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		});
	}
}
